'use strict';

var attrsKey = 'aaAttrs';

var _ = require('../common/utils.js');

var DOM = require('../common/dom.js');

var EventBus = require('./event_bus.js');

var Input = require('./input.js');

var Dropdown = require('./dropdown.js');

var html = require('./html.js');

var css = require('./css.js'); // constructor
// -----------
// THOUGHT: what if datasets could dynamically be added/removed?


function Typeahead(o) {
  var $menu;
  var $hint;
  o = o || {};

  if (!o.input) {
    _.error('missing input');
  }

  this.isActivated = false;
  this.debug = !!o.debug;
  this.autoselect = !!o.autoselect;
  this.autoselectOnBlur = !!o.autoselectOnBlur;
  this.openOnFocus = !!o.openOnFocus;
  this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
  this.autoWidth = o.autoWidth === undefined ? true : !!o.autoWidth;
  this.clearOnSelected = !!o.clearOnSelected;
  this.tabAutocomplete = o.tabAutocomplete === undefined ? true : !!o.tabAutocomplete;
  o.hint = !!o.hint;

  if (o.hint && o.appendTo) {
    throw new Error('[autocomplete.js] hint and appendTo options can\'t be used at the same time');
  }

  this.css = o.css = _.mixin({}, css, o.appendTo ? css.appendTo : {});
  this.cssClasses = o.cssClasses = _.mixin({}, css.defaultClasses, o.cssClasses || {});
  this.cssClasses.prefix = o.cssClasses.formattedPrefix = _.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix);
  this.listboxId = o.listboxId = [this.cssClasses.root, 'listbox', _.getUniqueId()].join('-');
  var domElts = buildDom(o);
  this.$node = domElts.wrapper;
  var $input = this.$input = domElts.input;
  $menu = domElts.menu;
  $hint = domElts.hint;

  if (o.dropdownMenuContainer) {
    DOM.element(o.dropdownMenuContainer).css('position', 'relative') // ensure the container has a relative position
    .append($menu.css('top', '0')); // override the top: 100%
  } // #705: if there's scrollable overflow, ie doesn't support
  // blur cancellations when the scrollbar is clicked
  //
  // #351: preventDefault won't cancel blurs in ie <= 8


  $input.on('blur.aa', function ($e) {
    var active = document.activeElement;

    if (_.isMsie() && ($menu[0] === active || $menu[0].contains(active))) {
      $e.preventDefault(); // stop immediate in order to prevent Input#_onBlur from
      // getting exectued

      $e.stopImmediatePropagation();

      _.defer(function () {
        $input.focus();
      });
    }
  }); // #351: prevents input blur due to clicks within dropdown menu

  $menu.on('mousedown.aa', function ($e) {
    $e.preventDefault();
  });
  this.eventBus = o.eventBus || new EventBus({
    el: $input
  });
  this.dropdown = new Typeahead.Dropdown({
    appendTo: o.appendTo,
    wrapper: this.$node,
    menu: $menu,
    datasets: o.datasets,
    templates: o.templates,
    cssClasses: o.cssClasses,
    minLength: this.minLength
  }).onSync('suggestionClicked', this._onSuggestionClicked, this).onSync('cursorMoved', this._onCursorMoved, this).onSync('cursorRemoved', this._onCursorRemoved, this).onSync('opened', this._onOpened, this).onSync('closed', this._onClosed, this).onSync('shown', this._onShown, this).onSync('empty', this._onEmpty, this).onSync('redrawn', this._onRedrawn, this).onAsync('datasetRendered', this._onDatasetRendered, this);
  this.input = new Typeahead.Input({
    input: $input,
    hint: $hint
  }).onSync('focused', this._onFocused, this).onSync('blurred', this._onBlurred, this).onSync('enterKeyed', this._onEnterKeyed, this).onSync('tabKeyed', this._onTabKeyed, this).onSync('escKeyed', this._onEscKeyed, this).onSync('upKeyed', this._onUpKeyed, this).onSync('downKeyed', this._onDownKeyed, this).onSync('leftKeyed', this._onLeftKeyed, this).onSync('rightKeyed', this._onRightKeyed, this).onSync('queryChanged', this._onQueryChanged, this).onSync('whitespaceChanged', this._onWhitespaceChanged, this);

  this._bindKeyboardShortcuts(o);

  this._setLanguageDirection();
} // instance methods
// ----------------


_.mixin(Typeahead.prototype, {
  // ### private
  _bindKeyboardShortcuts: function _bindKeyboardShortcuts(options) {
    if (!options.keyboardShortcuts) {
      return;
    }

    var $input = this.$input;
    var keyboardShortcuts = [];

    _.each(options.keyboardShortcuts, function (key) {
      if (typeof key === 'string') {
        key = key.toUpperCase().charCodeAt(0);
      }

      keyboardShortcuts.push(key);
    });

    DOM.element(document).keydown(function (event) {
      var elt = event.target || event.srcElement;
      var tagName = elt.tagName;

      if (elt.isContentEditable || tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA') {
        // already in an input
        return;
      }

      var which = event.which || event.keyCode;

      if (keyboardShortcuts.indexOf(which) === -1) {
        // not the right shortcut
        return;
      }

      $input.focus();
      event.stopPropagation();
      event.preventDefault();
    });
  },
  _onSuggestionClicked: function onSuggestionClicked(type, $el) {
    var datum;
    var context = {
      selectionMethod: 'click'
    };

    if (datum = this.dropdown.getDatumForSuggestion($el)) {
      this._select(datum, context);
    }
  },
  _onCursorMoved: function onCursorMoved(event, updateInput) {
    var datum = this.dropdown.getDatumForCursor();
    var currentCursorId = this.dropdown.getCurrentCursor().attr('id');
    this.input.setActiveDescendant(currentCursorId);

    if (datum) {
      if (updateInput) {
        this.input.setInputValue(datum.value, true);
      }

      this.eventBus.trigger('cursorchanged', datum.raw, datum.datasetName);
    }
  },
  _onCursorRemoved: function onCursorRemoved() {
    this.input.resetInputValue();

    this._updateHint();

    this.eventBus.trigger('cursorremoved');
  },
  _onDatasetRendered: function onDatasetRendered() {
    this._updateHint();

    this.eventBus.trigger('updated');
  },
  _onOpened: function onOpened() {
    this._updateHint();

    this.input.expand();
    this.eventBus.trigger('opened');
  },
  _onEmpty: function onEmpty() {
    this.eventBus.trigger('empty');
  },
  _onRedrawn: function onRedrawn() {
    this.$node.css('top', 0 + 'px');
    this.$node.css('left', 0 + 'px');
    var inputRect = this.$input[0].getBoundingClientRect();

    if (this.autoWidth) {
      this.$node.css('width', inputRect.width + 'px');
    }

    var wrapperRect = this.$node[0].getBoundingClientRect();
    var top = inputRect.bottom - wrapperRect.top;
    this.$node.css('top', top + 'px');
    var left = inputRect.left - wrapperRect.left;
    this.$node.css('left', left + 'px');
    this.eventBus.trigger('redrawn');
  },
  _onShown: function onShown() {
    this.eventBus.trigger('shown');

    if (this.autoselect) {
      this.dropdown.cursorTopSuggestion();
    }
  },
  _onClosed: function onClosed() {
    this.input.clearHint();
    this.input.removeActiveDescendant();
    this.input.collapse();
    this.eventBus.trigger('closed');
  },
  _onFocused: function onFocused() {
    this.isActivated = true;

    if (this.openOnFocus) {
      var query = this.input.getQuery();

      if (query.length >= this.minLength) {
        this.dropdown.update(query);
      } else {
        this.dropdown.empty();
      }

      this.dropdown.open();
    }
  },
  _onBlurred: function onBlurred() {
    var cursorDatum;
    var topSuggestionDatum;
    cursorDatum = this.dropdown.getDatumForCursor();
    topSuggestionDatum = this.dropdown.getDatumForTopSuggestion();
    var context = {
      selectionMethod: 'blur'
    };

    if (!this.debug) {
      if (this.autoselectOnBlur && cursorDatum) {
        this._select(cursorDatum, context);
      } else if (this.autoselectOnBlur && topSuggestionDatum) {
        this._select(topSuggestionDatum, context);
      } else {
        this.isActivated = false;
        this.dropdown.empty();
        this.dropdown.close();
      }
    }
  },
  _onEnterKeyed: function onEnterKeyed(type, $e) {
    var cursorDatum;
    var topSuggestionDatum;
    cursorDatum = this.dropdown.getDatumForCursor();
    topSuggestionDatum = this.dropdown.getDatumForTopSuggestion();
    var context = {
      selectionMethod: 'enterKey'
    };

    if (cursorDatum) {
      this._select(cursorDatum, context);

      $e.preventDefault();
    } else if (this.autoselect && topSuggestionDatum) {
      this._select(topSuggestionDatum, context);

      $e.preventDefault();
    }
  },
  _onTabKeyed: function onTabKeyed(type, $e) {
    if (!this.tabAutocomplete) {
      // Closing the dropdown enables further tabbing
      this.dropdown.close();
      return;
    }

    var datum;
    var context = {
      selectionMethod: 'tabKey'
    };

    if (datum = this.dropdown.getDatumForCursor()) {
      this._select(datum, context);

      $e.preventDefault();
    } else {
      this._autocomplete(true);
    }
  },
  _onEscKeyed: function onEscKeyed() {
    this.dropdown.close();
    this.input.resetInputValue();
  },
  _onUpKeyed: function onUpKeyed() {
    var query = this.input.getQuery();

    if (this.dropdown.isEmpty && query.length >= this.minLength) {
      this.dropdown.update(query);
    } else {
      this.dropdown.moveCursorUp();
    }

    this.dropdown.open();
  },
  _onDownKeyed: function onDownKeyed() {
    var query = this.input.getQuery();

    if (this.dropdown.isEmpty && query.length >= this.minLength) {
      this.dropdown.update(query);
    } else {
      this.dropdown.moveCursorDown();
    }

    this.dropdown.open();
  },
  _onLeftKeyed: function onLeftKeyed() {
    if (this.dir === 'rtl') {
      this._autocomplete();
    }
  },
  _onRightKeyed: function onRightKeyed() {
    if (this.dir === 'ltr') {
      this._autocomplete();
    }
  },
  _onQueryChanged: function onQueryChanged(e, query) {
    this.input.clearHintIfInvalid();

    if (query.length >= this.minLength) {
      this.dropdown.update(query);
    } else {
      this.dropdown.empty();
    }

    this.dropdown.open();

    this._setLanguageDirection();
  },
  _onWhitespaceChanged: function onWhitespaceChanged() {
    this._updateHint();

    this.dropdown.open();
  },
  _setLanguageDirection: function setLanguageDirection() {
    var dir = this.input.getLanguageDirection();

    if (this.dir !== dir) {
      this.dir = dir;
      this.$node.css('direction', dir);
      this.dropdown.setLanguageDirection(dir);
    }
  },
  _updateHint: function updateHint() {
    var datum;
    var val;
    var query;
    var escapedQuery;
    var frontMatchRegEx;
    var match;
    datum = this.dropdown.getDatumForTopSuggestion();

    if (datum && this.dropdown.isVisible() && !this.input.hasOverflow()) {
      val = this.input.getInputValue();
      query = Input.normalizeQuery(val);
      escapedQuery = _.escapeRegExChars(query); // match input value, then capture trailing text

      frontMatchRegEx = new RegExp('^(?:' + escapedQuery + ')(.+$)', 'i');
      match = frontMatchRegEx.exec(datum.value); // clear hint if there's no trailing text

      if (match) {
        this.input.setHint(val + match[1]);
      } else {
        this.input.clearHint();
      }
    } else {
      this.input.clearHint();
    }
  },
  _autocomplete: function autocomplete(laxCursor) {
    var hint;
    var query;
    var isCursorAtEnd;
    var datum;
    hint = this.input.getHint();
    query = this.input.getQuery();
    isCursorAtEnd = laxCursor || this.input.isCursorAtEnd();

    if (hint && query !== hint && isCursorAtEnd) {
      datum = this.dropdown.getDatumForTopSuggestion();

      if (datum) {
        this.input.setInputValue(datum.value);
      }

      this.eventBus.trigger('autocompleted', datum.raw, datum.datasetName);
    }
  },
  _select: function select(datum, context) {
    if (typeof datum.value !== 'undefined') {
      this.input.setQuery(datum.value);
    }

    if (this.clearOnSelected) {
      this.setVal('');
    } else {
      this.input.setInputValue(datum.value, true);
    }

    this._setLanguageDirection();

    var event = this.eventBus.trigger('selected', datum.raw, datum.datasetName, context);

    if (event.isDefaultPrevented() === false) {
      this.dropdown.close(); // #118: allow click event to bubble up to the body before removing
      // the suggestions otherwise we break event delegation

      _.defer(_.bind(this.dropdown.empty, this.dropdown));
    }
  },
  // ### public
  open: function open() {
    // if the menu is not activated yet, we need to update
    // the underlying dropdown menu to trigger the search
    // otherwise we're not gonna see anything
    if (!this.isActivated) {
      var query = this.input.getInputValue();

      if (query.length >= this.minLength) {
        this.dropdown.update(query);
      } else {
        this.dropdown.empty();
      }
    }

    this.dropdown.open();
  },
  close: function close() {
    this.dropdown.close();
  },
  setVal: function setVal(val) {
    // expect val to be a string, so be safe, and coerce
    val = _.toStr(val);

    if (this.isActivated) {
      this.input.setInputValue(val);
    } else {
      this.input.setQuery(val);
      this.input.setInputValue(val, true);
    }

    this._setLanguageDirection();
  },
  getVal: function getVal() {
    return this.input.getQuery();
  },
  destroy: function destroy() {
    this.input.destroy();
    this.dropdown.destroy();
    destroyDomStructure(this.$node, this.cssClasses);
    this.$node = null;
  },
  getWrapper: function getWrapper() {
    return this.dropdown.$container[0];
  }
});

function buildDom(options) {
  var $input;
  var $wrapper;
  var $dropdown;
  var $hint;
  $input = DOM.element(options.input);
  $wrapper = DOM.element(html.wrapper.replace('%ROOT%', options.cssClasses.root)).css(options.css.wrapper); // override the display property with the table-cell value
  // if the parent element is a table and the original input was a block
  //  -> https://github.com/algolia/autocomplete.js/issues/16

  if (!options.appendTo && $input.css('display') === 'block' && $input.parent().css('display') === 'table') {
    $wrapper.css('display', 'table-cell');
  }

  var dropdownHtml = html.dropdown.replace('%PREFIX%', options.cssClasses.prefix).replace('%DROPDOWN_MENU%', options.cssClasses.dropdownMenu);
  $dropdown = DOM.element(dropdownHtml).css(options.css.dropdown).attr({
    role: 'listbox',
    id: options.listboxId
  });

  if (options.templates && options.templates.dropdownMenu) {
    $dropdown.html(_.templatify(options.templates.dropdownMenu)());
  }

  $hint = $input.clone().css(options.css.hint).css(getBackgroundStyles($input));
  $hint.val('').addClass(_.className(options.cssClasses.prefix, options.cssClasses.hint, true)).removeAttr('id name placeholder required').prop('readonly', true).attr({
    'aria-hidden': 'true',
    autocomplete: 'off',
    spellcheck: 'false',
    tabindex: -1
  });

  if ($hint.removeData) {
    $hint.removeData();
  } // store the original values of the attrs that get modified
  // so modifications can be reverted on destroy


  $input.data(attrsKey, {
    'aria-autocomplete': $input.attr('aria-autocomplete'),
    'aria-expanded': $input.attr('aria-expanded'),
    'aria-owns': $input.attr('aria-owns'),
    autocomplete: $input.attr('autocomplete'),
    dir: $input.attr('dir'),
    role: $input.attr('role'),
    spellcheck: $input.attr('spellcheck'),
    style: $input.attr('style'),
    type: $input.attr('type')
  });
  $input.addClass(_.className(options.cssClasses.prefix, options.cssClasses.input, true)).attr({
    autocomplete: 'off',
    spellcheck: false,
    // Accessibility features
    // Give the field a presentation of a "select".
    // Combobox is the combined presentation of a single line textfield
    // with a listbox popup.
    // https://www.w3.org/WAI/PF/aria/roles#combobox
    role: 'combobox',
    // Let the screen reader know the field has an autocomplete
    // feature to it.
    'aria-autocomplete': options.datasets && options.datasets[0] && options.datasets[0].displayKey ? 'both' : 'list',
    // Indicates whether the dropdown it controls is currently expanded or collapsed
    'aria-expanded': 'false',
    'aria-label': options.ariaLabel,
    // Explicitly point to the listbox,
    // which is a list of suggestions (aka options)
    'aria-owns': options.listboxId
  }).css(options.hint ? options.css.input : options.css.inputWithNoHint); // ie7 does not like it when dir is set to auto

  try {
    if (!$input.attr('dir')) {
      $input.attr('dir', 'auto');
    }
  } catch (e) {// ignore
  }

  $wrapper = options.appendTo ? $wrapper.appendTo(DOM.element(options.appendTo).eq(0)).eq(0) : $input.wrap($wrapper).parent();
  $wrapper.prepend(options.hint ? $hint : null).append($dropdown);
  return {
    wrapper: $wrapper,
    input: $input,
    hint: $hint,
    menu: $dropdown
  };
}

function getBackgroundStyles($el) {
  return {
    backgroundAttachment: $el.css('background-attachment'),
    backgroundClip: $el.css('background-clip'),
    backgroundColor: $el.css('background-color'),
    backgroundImage: $el.css('background-image'),
    backgroundOrigin: $el.css('background-origin'),
    backgroundPosition: $el.css('background-position'),
    backgroundRepeat: $el.css('background-repeat'),
    backgroundSize: $el.css('background-size')
  };
}

function destroyDomStructure($node, cssClasses) {
  var $input = $node.find(_.className(cssClasses.prefix, cssClasses.input)); // need to remove attrs that weren't previously defined and
  // revert attrs that originally had a value

  _.each($input.data(attrsKey), function (val, key) {
    if (val === undefined) {
      $input.removeAttr(key);
    } else {
      $input.attr(key, val);
    }
  });

  $input.detach().removeClass(_.className(cssClasses.prefix, cssClasses.input, true)).insertAfter($node);

  if ($input.removeData) {
    $input.removeData(attrsKey);
  }

  $node.remove();
}

Typeahead.Dropdown = Dropdown;
Typeahead.Input = Input;
Typeahead.sources = require('../sources/index.js');
module.exports = Typeahead;